angular.module('app.filters').filter('unslugify', ($filter) => {
  'ngInject';

  function titlecase(s) {
    return s
      .toString()
      .toLowerCase()
      .replace(/\b([a-z])/g, function (ch) {
        return ch.toUpperCase();
      });
  }

  return (string) => {
    return titlecase((string || '').replace(/_/g, ' '));
  };
});



// WEBPACK FOOTER //
// ./app/filters/unslugify.js